import classNames from 'classnames';
import React, { useState } from 'react';

import { IterableForm } from '../iterableForm';
import { PortableText } from '../portableText';
import * as styles from './iterable.module.css';

export const Iterable = ({
	eyebrowTextOverride,
	headerTextOverride,
	iterableForm,
	formWidth,
	columnLayout,
	onSuccess = () => {},
	subheaderTextOverride,
}) => {
	// state
	const [formSubmitted, setFormSubmitted] = useState(false);

	const { eyebrowText, headerText, subheaderText, thankYouMessage } =
		iterableForm;

	return (
		<div className={styles.iterableContainer}>
			{formSubmitted && thankYouMessage && (
				<div className={styles.thankYouContainer}>
					<PortableText blocks={thankYouMessage} />
				</div>
			)}
			{!formSubmitted && headerText && (
				<div className={styles.headerContainer}>
					{(eyebrowTextOverride || eyebrowText) && (
						<p className={'heading-xs'}>
							{eyebrowTextOverride || eyebrowText}
						</p>
					)}
					{(headerTextOverride || headerText) && (
						<h2 className={'heading-l'}>
							{headerTextOverride || headerText}
						</h2>
					)}
					{(subheaderTextOverride || subheaderText) && (
						<p className={styles.descriptionText}>
							{subheaderTextOverride || subheaderText}
						</p>
					)}
				</div>
			)}

			{!formSubmitted && (
				// Add column prop here
				<IterableForm
					iterableForm={iterableForm}
					className={classNames(
						formWidth && formWidth,
						columnLayout && columnLayout
					)}
					onSuccess={onSuccess}
					setFormSubmitted={setFormSubmitted}
				/>
			)}
			{!formSubmitted && iterableForm?.disclaimer?.length && (
				<div className={styles.disclaimerContainer}>
					<PortableText
						blocks={iterableForm?.disclaimer}
						className='body-xs'
					/>
				</div>
			)}
			{!formSubmitted && !iterableForm?.disclaimer?.length && (
				<div className={styles.disclaimerContainer}>
					<p className={`${styles.disclaimer} body-s`}>
						By submitting this form, you are agreeing to Alma's{' '}
						<a
							href='https://secure.helloalma.com/pp/'
							target='_blank'
							rel='noreferrer'
						>
							privacy policy.
						</a>
					</p>
				</div>
			)}
		</div>
	);
};
